<app-dialog-header
	[title]="'dialog.vehicleAuctions.title'"
	variant="info"
	(closeClick)="close()"
></app-dialog-header>

<mat-dialog-content>
	<div class="rich-table-container">
		<!-- floatthead -->
		<table
			class="table table-striped rich-table tabella"
			[mfData]="auctions"
			#mf="appDataTable"
			[mfRowsOnPage]="tableData.rowsOnPage"
			[(mfSortBy)]="tableData.orderBy"
			[(mfSortOrder)]="tableData.sortOrder"
		>
			<thead class="rich-table-thead">
				<tr class="rich-table-subheader">
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="dateCreate">
							{{ "dialog.vehicleAuctions.dateCreate" | translate }}
						</app-default-sorter>
					</th>
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="auctionName">
							{{ "dialog.vehicleAuctions.auctionName" | translate }}
						</app-default-sorter>
					</th>
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="basePrice">
							{{ "dialog.vehicleAuctions.basePrice" | translate }}
						</app-default-sorter>
					</th>
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="maxOffer">
							{{ "dialog.vehicleAuctions.maxOffer" | translate }}
						</app-default-sorter>
					</th>
				</tr>
			</thead>
			<tbody>
				@for (element of mf.data; track element) {
					<tr class="rich-table-row rich-table-firstrow altclr">
						<td class="rich-table-cell text-center">{{ element?.dateCreate | ckDate }}</td>
						<td class="rich-table-cell text-center">{{ element?.auctionName }}</td>
						<td class="rich-table-cell text-center">{{ Math.floor(element?.basePrice) }}</td>
						<td class="rich-table-cell text-center">{{ element?.maxOffer }}</td>
					</tr>
				}
			</tbody>
			<tfoot>
				<tr>
					<td [attr.colspan]="tableData.col">
						<app-bootstrap-paginator [rowsOnPageSet]="rowsOnPageSet"></app-bootstrap-paginator>
					</td>
				</tr>
			</tfoot>
		</table>
	</div>
</mat-dialog-content>